import { Button, Modal } from 'antd';
import { strings } from '../../../lang';

type PreSalesPvDisqualifiedDialogProps = {
  open: boolean;
  isPvOnly: boolean;
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  messages: string[];
  onSubmit: () => void;
  onDismiss: () => void;
};

export const PreSalesPvDisqualifiedDialog = ({
  open,
  isPvOnly,
  isSubmitting,
  isSubmitDisabled,
  messages,
  onSubmit,
  onDismiss,
}: PreSalesPvDisqualifiedDialogProps) => (
  <Modal
    title={strings.preSalesQuestionnaire.pvDisqualifiedTitle}
    open={open}
    onCancel={onDismiss}
    footer={[
      <Button key="cancel" disabled={isSubmitting} onClick={onDismiss}>
        {strings.preSalesQuestionnaire.pvDeclineButton}
      </Button>,
      <Button
        key="continue"
        type="primary"
        loading={isPvOnly && isSubmitting}
        disabled={isPvOnly && isSubmitDisabled}
        onClick={isPvOnly ? onSubmit : onDismiss}
      >
        {strings.preSalesQuestionnaire.pvContinueHeatButton}
      </Button>,
    ]}
  >
    <p>{isPvOnly
      ? strings.preSalesQuestionnaire.pvOnlyDisqualifiedDescription
      : strings.preSalesQuestionnaire.pvDisqualifiedDescription}</p>
    {messages.length > 0 && (
      <ul className="bp-presales-questionnaire__cancellation-list">
        {messages.map((message) => <li key={message}>{message}</li>)}
      </ul>
    )}
  </Modal>
);
